function formatAnswer(answer, topicId) {
  if (topicId === 1) return answer;
  if (topicId === 2 || topicId === 4) {
    return typeof answer === 'object' ? `${answer.num}/${answer.den}` : String(answer);
  }
  if (topicId === 3) return String(answer);
  if (topicId === 5) {
    return typeof answer === 'object' ? `${answer.num}/${answer.den}` : String(answer);
  }
  return String(answer);
}

export default function ResultsPage({ context, onHome, onRetry }) {
  const { topicId, score, total, answers } = context;
  const pct = Math.round((score / total) * 100);

  const medal =
    pct === 100 ? '🥇' :
    pct >= 80   ? '🥈' :
    pct >= 50   ? '🥉' : '😞';

  return (
    <div className="results-page">
      <h2>Rezultāts</h2>

      <div className="score-display">
        <span className="score-medal">{medal}</span>
        <span className="score-fraction">{score} / {total}</span>
        <span className="score-pct">{pct}%</span>
      </div>

      <div className="answer-breakdown">
        {answers.map((a, i) => (
          <div
            key={a.questionId}
            className={`answer-row ${a.isCorrect ? 'correct' : 'wrong'}`}
          >
            <span className="answer-num">{i + 1}.</span>
            <span className="answer-icon">{a.isCorrect ? '✓' : '✗'}</span>
            {!a.isCorrect && (
              <span className="correct-hint">
                Pareizā: {formatAnswer(a.correctAnswer, topicId)}
              </span>
            )}
          </div>
        ))}
      </div>

      <div className="results-actions">
        <button className="btn-secondary" onClick={onHome}>
          Uz sākumu
        </button>
        <button className="btn-primary" onClick={onRetry}>
          Mēģināt vēlreiz
        </button>
      </div>
    </div>
  );
}
